export const faqSchema = {
  'medical-fundraising': {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': [
      {
        '@type': 'Question',
        'name': ' What medical treatments can you raise funds for?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '<ul><li> Open Heart Surgery</li><li> Kidney Transplant</li><li> NICU Care</li><li> Bone Marrow Transplant</li><li> Cancer treatment</li><li> other several critical illnesses</li></ul>'
        }
      },
      {
        '@type': 'Question',
        'name': 'Why are people choosing medical crowdfunding?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'Medical emergencies come without a warning. At times, health insurance and savings are not enough to cover the expensive bill. Crowdfunding helps you reach your goal by getting small contributions from a large group of people.'
        }
      },
      {
        '@type': 'Question',
        'name': 'I want to start a medical fundraiser. What all do i need?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'For your fundraiser to be as transparent as possible, upload a scanned copy of your hospital bill mentioning the medical condition and the amount you require along with high resolution photograph of the patient.'
        }
      },
      {
        '@type': 'Question',
        'name': 'I don’t see the medical treatment I want to raise funds for in the list, what do I do?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'You can raise funds for - Bone Marrow Transplant, Kidney Transplant, NICU Care(in case of premature babies), Cancer Treatment, Open Heart Surgery, Heart defect, Brain tumor, Cerebral Palsy, Aplastic Anaemia, Joint Replacement, Eye Surgery. However, if your treatment option isn’t mentioned here, you can get in touch with us to get assistance - someone from our team will get in touch with you.'
        }
      },
      {
        '@type': 'Question',
        'name': 'I want to start raising funds, how do I start a fundraiser on Ketto?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '<a href=https://www.ketto.org/new/crowdfunding> Starting a fundraiser on Ketto</a> takes just 3 minutes and signing up is absolutely free*. Just sign up, fill details of what you need money for and hit submit.'
        }
      },
      {
        '@type': 'Question',
        'name': 'I have more questions, who do I write to?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'You can write to info@ketto.org. Know someone who needs funds for medical treatment urgently? Help them out by sharing this information with them.'
        }
      }
    ]
  },
  'help-children': {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': [
      {
        '@type': 'Question',
        'name': 'Which causes can I raise funds for?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'You can raise funds for sponsoring meals, education, sports training, sanitation or any other cause that promises to bring about a positive change in a child’s life.'
        }
      },
      {
        '@type': 'Question',
        'name': 'I don’t have any NGO but I want to feed poor children this diwali?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'That’s a lovely thought! You can choose an NGO that works towards this cause and start a fundraiser for them.'
        }
      },
      {
        '@type': 'Question',
        'name': 'Can I raise funds for any orphan/street child?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'Absolutely! Just zero down on a cause, write a compelling a story about why the child needs help and start a fundraiser.'
        }
      },
      {
        '@type': 'Question',
        'name': 'What can you raise funds for?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '<ul><li> Paying for Medical Treatments</li><li> Supporting child education</li><li> Sponsoring Health Meals</li><li> Supporting Child Athletes</li><li>Become a Champion for an NGO</li></ul>'
        }
      },
      {
        '@type': 'Question',
        'name': 'Why are people choosing crowdfunding?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '<ul><li> Helping Parents of Ailing Children</li><li> Helping Parents without privileges</li><li> Giving Wings to Deserving Children</li><li>Become a Champion for an NGO</li></ul>'
        }
      },
      {
        '@type': 'Question',
        'name': 'I have more questions, who do I write to?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'You can write to info@ketto.org'
        }
      }
    ]
  },
  'animal-fundraising': {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': [
      {
        '@type': 'Question',
        'name': 'Which animals can I raise funds for?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'Be it a stray dog, cat, cow or even a crow - you can raise for any animal in need.'
        }
      },
      {
        '@type': 'Question',
        'name': 'My NGO is not associated with Ketto ,can I still rasie funds for their projects?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'Absolutely! We’ll be more than happy to help them raise funds so their project can come to life.'
        }
      },
      {
        '@type': 'Question',
        'name': 'What causes can I raise funds for?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'You can raise funds for sterilisation of animals, feeding animals, their medical treatment, adoption, or to support an NGO of your choice. If you want to raise funds for something else, we’ll be more than happy to assist you.'
        }
      },
      {
        '@type': 'Question',
        'name': 'What can you raise funds for?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '<ul><li> Sterlisation Programmes</li><li> Medical Treatment</li><li> Sponsoring Meals</li><li>Animal Shelters</li><li>Making Documentaries</li></ul>'
        }
      },
      {
        '@type': 'Question',
        'name': 'Why are animal lovers choosing crowdfunding?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '<ul><li> Looking After Multiple Animals</li><li> High Veterinary Charges</li><li> Championing For NGOs</li><li>Creating A Better World For Animals</li></ul>'
        }
      },
      {
        '@type': 'Question',
        'name': 'I have more questions, who do I write to?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'You can write to info@ketto.org'
        }
      }
    ]
  },
  'creative-fundraising': {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': [
      {
        '@type': 'Question',
        'name': 'Can I raise funds at the first stage of my business/for my idea/as initial commencement funds?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'Absolutely! Just make sure your potential supporters know all details they need to understand your idea.'
        }
      },
      {
        '@type': 'Question',
        'name': 'Do I have to repay my supporters?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'Not at all. You can repay your supporters by posting a heartfelt thank you, rewards and regular updates about the progress of your fundraiser.'
        }
      },
      {
        '@type': 'Question',
        'name': 'Will I get any help to understand how to go about the fundraiser?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'Yes. A dedicated campaign manager will help you with the launch, pre launch and post launch strategy throughout your campaign.'
        }
      },
      {
        '@type': 'Question',
        'name': 'What can you raise funds for?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '<ul><li> Innovative Idea</li><li> Film and Documentaries</li><li> Theatre</li><li> Book Publishing</li><li> Music</li></ul>'
        }
      },
      {
        '@type': 'Question',
        'name': 'Why are entrepreneurs choosing crowdfunding?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '<ul><li>Testing your idea</li><li> Pre-selling</li><li>Easy Way to get Funds</li><li> Pitch directly to consumer</li></ul>'
        }
      },
      {
        '@type': 'Question',
        'name': 'I have more questions, who do I write to?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'You can write to info@ketto.org'
        }
      }
    ]
  },
  'fundraising-for-education': {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': [{
      '@type': 'Question',
      'name': 'What is Education Crowdfunding in India?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Education Crowdfunding helps teachers, students and NGOs raise funds to buy classroom supplies and much more.'
      }
    },
    {
      '@type': 'Question',
      'name': 'Why Start an Education Fundraiser with Ketto?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Education Crowdfunding on Ketto’s online crowdfunding platform is Effective, Swift and Simple.'
      }
    }, {
      '@type': 'Question',
      'name': 'Who can Start An Education Crowdfunding Campaign on Ketto?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Students can Start An Education Fundraising Campaign for themselves or provide support to a friend’s education campaign. Parents can Start An Education Crowdfunding Campaign for their Child\'s Future Education.'
      }
    }, {
      '@type': 'Question',
      'name': 'For what purpose can you raise funds for?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': `You can raise education crowdfunding for the following purpose
    <ol>
      <li>Public Schools</li>
      <li>Educational Associations</li>
      <li>After School Programs</li>
      <li>Parent Teacher Associations</li>
      <li>Extracurricular Programs</li>
    </ol>`
      }
    }, {
      '@type': 'Question',
      'name': 'Why choose Ketto to Raise Funds for Education?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': `<ol>
      <li>Payout</li>
      <li>International Payment Support</li>
      <li>24*7 Support</li>
      <li>Dedicated Fundraiser Expert</li>
    </ol>`
      }
    }, {
      '@type': 'Question',
      'name': 'What Does Crowdfunding for Education on Ketto Offer?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': `<ol>
      <li>0% Platform Fee*</li>
      <li>Amount raised after the transactional processing fee is yours to keep</li>
      <li>Accept contributions from all cards, net banking, UPI and online wallets</li>
      <li>Instantly Withdraw Of Funds without any hassle directly to your bank account</li>
      <li>Multiple people can manage and fundraise for your cause</li>
      <li>Receive instant updates of fundraiser's progress on a real-time dashboard</li>
    </ol>`
      }
    }, {
      '@type': 'Question',
      'name': 'How I can start Education Crowdfunding?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Starting a fundraiser on Ketto takes just 3 minutes, and signing up is free*. Just sign up, fill in details of what you need money for and hit submit.'
      }
    }, {
      '@type': 'Question',
      'name': 'What all documents do I need to submit?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'All campaigners undergo a KYC verification based on the submitted legal identity proofs and other supporting documents. PAN card Address proof - Aadhar card (front and back) or Passport (first and last page) or Election card (front and back), or Driver\'s license.'
      }
    }, {
      '@type': 'Question',
      'name': 'How much I can raise for my education?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'You can reach out to our support team to get advice on much you should raise for your education.'
      }
    }, {
      '@type': 'Question',
      'name': 'Can I raise funds for Overseas Universities Education?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Yes! You can raise funds to pay for your education in overseas universities.'
      }
    }, {
      '@type': 'Question',
      'name': 'What is the withdrawal process?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'To withdraw funds in your bank account, you need to submit your bank account details and documents per Ketto\'s requirements.'
      }
    }, {
      '@type': 'Question',
      'name': 'I have more questions regarding fundraising for education; whom do I write to?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'You can write to info@ketto.org. Just drop your queries and get answers to your doubts.'
      }
    }]
  },
  'cancer-crowdfunding': {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': [{
      '@type': 'Question',
      'name': 'What is Cancer Crowdfunding?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Crowdfunding to raise funds for cancer treatment expense and chemotherapy drugs is called cancer crowdfunding.'
      }
    }, {
      '@type': 'Question',
      'name': 'How does cancer crowdfunding work?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Log in on the online crowdfunding platform of Ketto, select start a new campaign, set a fundraising goal, fill in few mandatory details, create your crowdfunding campaign page, and promote your campaign.'
      }
    }, {
      '@type': 'Question',
      'name': 'How can Ketto help you To Fund Your Cancer Treatment?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'You can start a cancer crowdfunding campaign for free on Ketto & raise funds to pay for your or a close relative and friends cancer treatments and cancer-related medical bills.'
      }
    },
    {
      '@type': 'Question',
      'name': 'Types of Cancers that you can raise funds for on Ketto?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': `Different types of cancers that you can raise funds for on Ketto are:
        <ol>
          <li>Leukemia & Lymphoma</li>
          <li>Lung Cancer</li>
          <li>Prostate Cancer</li>
          <li>Kidney Cancer</li>
          <li>Breast Cancer</li>
          <li>Throat Cancer</li>
        </ol>`
      }
    }, {
      '@type': 'Question',
      'name': 'Why are people choosing cancer crowdfunding with Ketto?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': `
          <ol>
            <li>High Cost Of Treatment</li>
            <li>Asking For Money Isn’t Easy</li>
            <li>Emergencies Demand A Prompt Response</li>
            <li>Loan Repayment Is Stressful</li>
          </ol>
        `
      }
    }, {
      '@type': 'Question',
      'name': 'What Ketto Offers?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': `
          <ol>
            <li>Starting a fundraiser on Ketto is absolutely free</li>
            <li>24x7 assistance from dedicated fundraiser managers throughout your fundraising journey</li>
            <li>We accept contributions in multiple currencies from anywhere in the world</li>
            <li>You can withdraw your funds at any poin</li>
            <li>Get instant updates on your fundraiser's progress</li>
            <li>Accepts contributions all cards, netbanking, UPI and online wallets</li>
          </ol>
        `
      }
    }, {
      '@type': 'Question',
      'name': 'I want to start a medical fundraiser. What all do i need?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'For your fundraiser to be as transparent as possible, upload a scanned copy of your hospital bill mentioning the medical condition and the amount you require along with high resolution photograph of the patient.'
      }
    }, {
      '@type': 'Question',
      'name': 'I don’t see the medical treatment I want to raise funds for in the list, what do I do?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'You can raise funds for - Bone Marrow Transplant, Kidney Transplant, NICU Care(in case of premature babies), Cancer Treatment, Open Heart Surgery, Heart defect, Brain tumor, Cerebral Palsy, Aplastic Anaemia, Joint Replacement, Eye Surgery. However, if your treatment option isn’t mentioned here, you can get in touch with us to get assistance - someone from our team will get in touch with you.'
      }
    }, {
      '@type': 'Question',
      'name': 'I want to start raising funds, how do I start a fundraiser on Ketto?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Starting a fundraiser on Ketto takes just 3 minutes and signing up is absolutely free*. Just sign up, fill details of what you need money for and hit submit.'
      }
    }, {
      '@type': 'Question',
      'name': 'I have more questions, who do I write to?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'You can write to info@ketto.org. Know someone who needs funds for medical treatment urgently? Help them out by sharing this information with them.'
      }
    }]
  },
  'sports-crowdfunding': {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': [
      {
        '@type': 'Question',
        'name': 'What is Ketto Crowdfunding?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'Ketto is the world’s leading crowdfunding platform for athletes, teams, and clubs.'
        }
      },
      {
        '@type': 'Question',
        'name': 'Who is Ketto for?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'Ketto is for individuals, teams, clubs, events, and even sporting entrepreneurs.'
        }
      },
      {
        '@type': 'Question',
        'name': 'Why use Ketto?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'Because our crowdfunding platform allows all individuals and teams to raise funds quickly and efficiently using the best tools available.'
        }
      },
      {
        '@type': 'Question',
        'name': 'Is Ketto Crowdfunding secure?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'We employ the best secure payment encryption technology available. Donors’ online payments are safe and your money is stored securely until your campaign is complete.'
        },
      },
      {
        '@type': 'Question',
        'name': 'What does it cost to raise money on Ketto?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'Ketto Charges 0% Platform Fees*.'
        },
      },
      {
        '@type': 'Question',
        'name': 'Can anybody create a Sports funding campaign?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'Any individual for themselves or for another, or an individual on behalf of a club or team can use Ketto’s to start a sports fundraising Campaign.'
        },
      },
      {
        '@type': 'Question',
        'name': 'How do I know when a supporter makes a contribution?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'You will receive an alert from us each time a contribution is made plus it will also appear on your campaign page.'
        }
      }
    ]
  },
  'transplant-crowdfunding': {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': [{
      '@type': 'Question',
      'name': 'How I can start Transplant Crowdfunding?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Starting a fundraiser on Ketto takes just 3 minutes, and signing up is free*. Just sign up, fill in details of what you need money for, and hit submit.'
      }
    },
    {
      '@type': 'Question',
      'name': 'What all documents do I need to submit?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': "All campaigners undergo a KYC verification based on the submitted legal identity proofs and other supporting documents. PAN card Address proof - Aadhar card (front and back), Passport (first and last page), Election card (front and back), or Driver's license."
      }
    },
    {
      '@type': 'Question',
      'name': 'How much can I raise for my Transplant?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'You can reach out to our support team to get advice on much you should raise for your Transplant.'
      }
    },
    {
      '@type': 'Question',
      'name': 'What is the withdrawal process?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': "To withdraw funds in your bank account, you must submit your bank account details and documents per Ketto's requirements."
      },
    },
    {
      '@type': 'Question',
      'name': 'I have more questions regarding fundraising for Transplants; whom do I write to?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'You can write to info@ketto.org. Just drop your queries and get answers to your doubts.'
      }
    }]
  }
};
